import translator from "./translator";
var lang = {
    1: {
        "my_education": "Moje vzdelávanie",
        "view_profile": "Pozrieť profil"
    },
    2: {
        "my_education": "My education",
        "view_profile": "View Profile"
    },
    3: {
        "view_profile": "Magyar Profile"
    }
};
export default (txt) => {
    var l = translator.getCurrent();
    if (lang[l]) {
        if (lang[l][txt]) {
            return lang[l][txt];
        }
    }
    return txt;
}





// WEBPACK FOOTER //
// ./src/public_app/api/translation.js